import { Injectable } from '@angular/core';
// tslint:disable-next-line:ban-types
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private eventCategory = 'Klađenje';
  constructor() { }

  public eventEmitter(
    eventAction: string,
    // eventCategory = 'Klađenje',
    event_label: string = null,
    value: string = null ) {
      return;
      gtag('event', eventAction, {
        event_category: this.eventCategory,
        event_label,
        value
      });
    }
}
